import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { segment } from '@actions/analytics';

import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import { WEB_PAGE_VIEW_EVENT } from '@constants/segment';

const triggerWebPageViewEvent = () => {
  segment.track(WEB_PAGE_VIEW_EVENT, { use_segment_api: true });
};

const useSegmentPageView = () => {
  const { asPath } = useRouter();
  const isUserDataLoaded = useMyInfo(getIsLoggedIn);
  const { isLoading: isUserDataLoading, isValidating: userDataNeedsLoading } =
    useMyInfo();

  const isUserLoggedIn = !isUserDataLoading && isUserDataLoaded;
  const isUserLoggedOut = !userDataNeedsLoading && !isUserDataLoaded;

  useEffect(() => {
    if (isUserLoggedIn || isUserLoggedOut) triggerWebPageViewEvent();
  }, [asPath, isUserLoggedOut, isUserLoggedIn]);
};

export default useSegmentPageView;
